import '../css/Dashboardpage.css';
import DocumentRequest from '../model/request/Documentrequest';
import DocumentstatusResponse from '../model/response/DocumentstatusResponse';
import ContactRequest from '../model/request/ContactRequest';
import { Oval } from "react-loader-spinner";
import Popup from './Popup';
import { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import UpdateDetailsResponse from '../model/response/UpdateDetailsResponse';


import { toast, ToastContainer } from 'react-toastify';
import ApiConfig from '../utils/ApiConfig';
import axios from 'axios';
import ApiResponse from '../model/response/ApiResponse';




function NumberEditpopup() {
    const rawVal = localStorage.getItem('loginVal');
    let loginVal = rawVal ? JSON.parse(rawVal) : null;
    let token = loginVal ? loginVal.token : null;

    var location = useLocation();
    var { profile } = location.state || {};

    const [number, setNumber] = useState();
    const [errors, setErrors] = useState({});
    const [activeuser, setActiveUser] = useState([]);
    const [showNumberUpdate, setShowNumberUpdate] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const navigation = useNavigate()

    function validate() {
        const newErrors = {};

        if (!number.trim()) {
            newErrors.number = 'Please enter your number';
        } else if (!/^[0-9]{10}$/.test(number)) {
            newErrors.number = 'Enter a valid 10-digit number';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    }

    async function handleSubmit() {
        if (validate()) {
            number = await ApiConfig.encrypt(number);

        }
    }


    function showToast(message) {
        toast.success(message, {
            position: "top-right",
            autoClose: 2000
        });
    }
    function showToastFailed(message) {
        toast.error(message, {
            position: "top-right",
            autoClose: 2000
        });
    }

    useEffect(() => {
        setIsLoading(true);


    }, []);

    async function NumberNewUpdate() {

        if (!validate()) return;

        setIsLoading(true);

        var request = new DocumentRequest();

        request.userId = loginVal.user_Id;
        request.contact =await ApiConfig.encrypt(number);
         request.isPhone = true;
         request.isEmail = false;


        console.log("Request:", JSON.stringify(request));

        axios.put(
            ApiConfig.getUrl("User/updateContact"),
            JSON.stringify(request),
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            }
        )
            .then(response => {

                const api = ApiResponse.fromJson(response.data);

                if (api.statusCode == 200 && api.status == true) {
                    //    navigation('/Viewpage', { state: { userId: userId } });

                    showToast(api.response.message);
                     navigation('/ContactOtpscreen', { state: { userId: loginVal.user_Id, contact:number,isPhone:true,isEmail:false} });
                  
                    setIsLoading(false);

                } else {

                    showToastFailed(api.message);
                }
            })
            .catch(error => {

                console.error(error);

                setIsLoading(false);

                showToastFailed("Update failed");
            });
    }


    function clicktoEditprofile() {
        navigation('/Editprofile')

        setIsLoading(true);

    }

const disableRightClick = (e) => {
    e.preventDefault();
  };

    return (

        <div className='text-center' onContextMenu={disableRightClick}>


            
  <h2>Mobile Number Update</h2>

                <input
                    type="text"
                    placeholder="Enter your Number.."
                    className="w-75 mt-3 p-2"
                    value={number}
                    onChange={(e) => setNumber(e.target.value)}
                />
                <span className="text-danger text-decoration-none">{errors.number}</span><br/>




                <div className="btn-group mt-3">
                    <button style={{ backgroundColor: "var(--primary-color)" }} onClick={NumberNewUpdate} className="btn">Save</button>
                    <button style={{ backgroundColor: "lightgrey" }} className="btn" onClick={clicktoEditprofile}> Cancel</button>
                </div>
            
        </div>
        // <div>



    );
}

export default NumberEditpopup;

//

// 